<template>
  <div id="table-instances" class="table-instances-container">
    <vs-table
      ref="tableInstances"
      noDataText="Nenhum grupo disponível para selecionar"
      pagination
      multiple
      :max-items="itemsPerPage"
      search
      v-model="selectedInstances"
      :data="instances"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    instances.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : instances.length
              }} de {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th v-if="showTenant" sort-key="tenant">Tenant</vs-th>
        <vs-th sort-key="status">Status</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-email font-medium truncate">{{ tr.instance.name }}</p>
            </vs-td>

            <vs-td v-if="showTenant">
              <p class="font-medium truncate">{{ tr.instance.tenancy_name }}</p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getConnectionStatusColor(tr.instance.activated)" class="product-order-status">
                {{ getConnectionStatusName(tr.instance.activated) | title }}
              </vs-chip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-button 
      class="float-left" 
      @click="saveInstancesOnCustomer" 
      :disabled="!selectedInstances.length"
    >
      {{ confirmButtonLabel }}
    </vs-button>
  </div>
</template>

<script>
  export default {
    name: 'table-instances',
    props: {
      instances: {
        type: Array,
        required: true
      },
      addInstancePopupActive: Boolean,
      showTenant: {
        type: Boolean,
        default: false
      },
      confirmButtonLabel: {
        type: String,
        default: 'Selecionar Conexões'
      }
    },
    data() {
      return {
        itemsPerPage: 4,
        isMounted: false,
        selectedInstances: []
      }
    },
    watch: {
      addInstancePopupActive: function () {
        this.selectedInstances = []
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.tableInstances.currentx
        }

        return 0
      },
      queriedItems() {
        return this.$refs.tableInstances ? this.$refs.tableInstances.queriedResults.length : this.instances.length
      }
    },
    methods: {
      saveInstancesOnCustomer() {
        this.$emit('saveInstancesOnCustomer', this.selectedInstances)
      },
      getConnectionStatusName(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'Conectado'
        }

        return 'Desconectado'
      },
      getConnectionStatusColor(activated) {
        if (activated !== false && activated !== 'false' && activated !== 0 && activated !== '0') {
          return 'success'
        }

        return 'danger'
      },
    },
    mounted() {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  #table-instances {
    width: 100%;

    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
